module.exports = __webpack_public_path__ + "img/Bitmap1.8e0a9fcd.png";